import React from 'react';
import { FaGuitar } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const products = [
  {
    id: 1,
    name: 'Fender Stratocaster',
    brand: 'Fender',
    price: '$1,199',
    image: 'https://cartervintage.com/sized-images/2BA6HRjgtWtExGwfsgBD6nYtxhV/2HaTw0HLBpdsaH4Q1IVcK7Q1rCS/product.jpeg',
  },
  {
    id: 2,
    name: 'Gibson Les Paul',
    brand: 'Gibson',
    price: '$2,499',
    image: 'https://cartervintage.com/sized-images/2BA6HRjgtWtExGwfsgBD6nYtxhV/2ZY2CWEW8oJmj58QYhEI9s7lmvq/product.jpeg',
  },
  {
    id: 3,
    name: 'Gibson SG Special 1961',
    brand: 'Gibson',
    price: '$9,200',
    image: 'https://cartervintage.com/sized-images/2BA6HRjgtWtExGwfsgBD6nYtxhV/2h6SLVFD0O2655Ofx6ABic9AnAP/product.jpeg',
    description: 'A modern guitar favored by rock and metal guitarists.',
  },
  // Add more products as needed
];

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <header className="bg-red-600 text-white py-6">
        <div className="container mx-auto flex items-center justify-center">
          <FaGuitar className="text-4xl mr-2" />
          <h1 className="text-3xl font-bold">Guitar Store</h1>
        </div>
      </header>
      <main className="container mx-auto py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map(product => (
            <Link key={product.id} to={`/product/${product.id}`} className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-200">
              <img src={product.image} alt={product.name} className="w-full h-48 object-cover rounded-t-lg" />
              <div className="mt-4">
                <h2 className="text-xl font-semibold">{product.name}</h2>
                <p className="text-gray-600">{product.brand}</p>
                <p className="text-gray-800 mt-2">{product.price}</p>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}

export default HomePage;